<template>
  <Container name="ingredients">
    <template slot="first">
      <section class="section">
        <Title title="Królewskie" subtitle="Jasne pełne" reverse-colors />

        <span class="text">
          Piwo jasne, pasteryzowane
        </span>
      </section>

      <section class="section">
        <Title title="Alkohol" />

        <span class="text">
          5,2% obj.
        </span>
      </section>
    </template>

    <template slot="second">
      <section class="section">
        <Title title="Składniki" />

        <span
          class="text"
          v-html="
            'woda, słód jęczmienny, kukurydza, jęczmień, ekstrakt z&nbsp;chmielu i&nbsp;chmiel'
          "
        />
      </section>

      <section class="section">
        <Title title="Wartości odżywcze" subtitle="w 100 ml" />

        <ul class="values">
          <li class="item">
            <span class="text name">Wartość energetyczna</span>
            <span class="text value">168 kJ / 40 kcal</span>
          </li>

          <li class="item">
            <span class="text name">Tłuszcz</span>
            <span class="text value"
              >0 g
              <span
                class="text text--small value"
                v-html="'( w tym kwasy tłuszczowe nasycone 0&nbsp;g&nbsp;)'"
              />
            </span>
          </li>

          <li class="item">
            <span class="text name">Węglowodany</span>
            <span class="text value">2,5 g</span>
          </li>

          <li class="item">
            <span class="text name">w tym cukry</span>
            <span class="text value">0,7 g</span>
          </li>

          <li class="item">
            <span class="text name">Białko</span>
            <span class="text value">0,3 g</span>
          </li>

          <li class="item">
            <span class="text name">Sól</span>
            <span class="text value">&lt; 0,01 g</span>
          </li>
        </ul>
      </section>
    </template>
  </Container>
</template>

<script>
import Title from '../common/Title'
import Container from '@/components/popups/PopupContainer'

export default {
  components: {
    Container,
    Title
  }
}
</script>

<style lang="scss" scoped>
.section {
  margin-bottom: 70px;

  @include media-down(xl) {
    margin-bottom: 43px;
  }

  @include media-down(lg) {
    margin-bottom: 25px;
  }

  @include media-down(md) {
    margin-bottom: 12px;
  }
}

/deep/ .title {
  margin-bottom: 24px;

  @include media-down(xl) {
    margin-bottom: 15px;
  }

  @include media-down(lg) {
    font-size: 60px;
    margin-bottom: 8px;
  }

  @include media-down(md) {
    font-size: 28px;
    margin-bottom: 0;
  }
}

.text {
  text-transform: uppercase;
  letter-spacing: 0.05em;
  line-height: 1.4em;
  font-size: 18px;

  @include media-down(xl) {
    font-size: 12px;
  }
  @include media-down(lg) {
    font-size: 20px;
  }
  @include media-down(md) {
    font-size: 10px;
  }

  &--small {
    @include hide-down(lg) font-size: 12px;

    @include media-down(xl) {
      font-size: 8px;
    }
  }
}

.name {
  display: inline-flex;
  width: 48%;
}
</style>
